import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { PageNames, Role } from "../types/AppTypes";
import { Collaborators } from "../screens/Collaborators/Collaborators";
import CollaboratorDetail from "../screens/CollaboratorDetail/CollaboratorDetail";
import { PotentialMatrix } from "../screens/PotentialMatrix/PotentialMatrix";

import { AreaDevelopment } from "../screens/AreaDevelopment/AreaDevelopment";
import { Faq } from "../screens/Faq/Faq";
import { PageFormatter } from "../components/PageFormatter/PageFormatter";
import { Formation } from "../screens/Formation/Formation";
import { TechSkills } from "../screens/TechSkills/TechSkills";
import { Management } from "../screens/Management/Management";
import { Org } from "../screens/Org/Org";
import { CareerManagers } from "../screens/CareerManagers/CareerManagers";
import { PersonalProfile } from "../screens/PersonalProfile/PersonalProfile";
import { CareerManagerDetail } from "../screens/CareerManagerDetail/CareerManagerDetail";
import { PrivacyPolicy } from "../screens/PrivacyPolicy/PrivacyPolicy";
import { AuthProfile } from "../types/api/auth.type";
import { PotentialMatrixV3 } from "../screens/PotentialMatrixV3/PotentialMatrixV3";

type AppRouterProps = {
  loadAppData: () => Promise<void>;
  profile: AuthProfile;
  setDataLoaded: (loaded: boolean) => void;
  logout: () => void;
};

export const AppRouter = ({
  profile,
  loadAppData,
  setDataLoaded,
  logout,
}: AppRouterProps) => {
  const isCollaborator = () => {
    return profile.role === Role.COLLABORATOR && !profile.isCm;
  };

  return (
    <Routes>
      <Route
        path="/"
        element={
          <Navigate
            to={
              isCollaborator()
                ? PageNames.PERSONAL_PROFILE
                : PageNames.COLLABORATORS
            }
            replace
          />
        }
      />
      <Route
        element={
          <PageFormatter
            loadAppData={loadAppData}
            setDataLoaded={setDataLoaded}
            logout={logout}
          />
        }
      >
        <Route path={PageNames.ORG} element={<Org />} />
        <Route path={PageNames.COLLABORATORS} element={<Collaborators />} />
        <Route
          path={`${PageNames.COLLABORATORS}/:collaboratorId`}
          element={<CollaboratorDetail />}
        />
        <Route
          path={PageNames.POTENTIAL_MATRIX}
          element={<PotentialMatrix />}
        />
        <Route
          path={PageNames.POTENTIAL_MATRIXV3}
          element={<PotentialMatrixV3 />}
        />
        <Route
          path={PageNames.AREA_DEVELOPMENT}
          element={<AreaDevelopment />}
        />
        <Route path={PageNames.FORMATION} element={<Formation />} />
        <Route path={PageNames.TECH_SKILLS} element={<TechSkills />} />
        <Route path={PageNames.CAREER_MANAGER} element={<CareerManagers />} />
        <Route
          path={`${PageNames.CAREER_MANAGER}/:careerManagerId`}
          element={<CareerManagerDetail />}
        />
        <Route
          path={`${PageNames.CAREER_MANAGER}/:careerManagerId/collaborators/:collaboratorId`}
          element={<CollaboratorDetail />}
        />
        <Route path={PageNames.MANAGEMENT} element={<Management />} />
        <Route
          path={`${PageNames.MANAGEMENT}/collaborators/:collaboratorId`}
          element={<CollaboratorDetail />}
        />
        <Route
          path={PageNames.PERSONAL_PROFILE}
          element={<PersonalProfile />}
        />
        <Route
          path={`${PageNames.MANAGEMENT}${PageNames.PERSONAL_PROFILE}`}
          element={<PersonalProfile />}
        />
      </Route>
      <Route path={PageNames.FAQ} element={<Faq />} />
      <Route path={PageNames.PRIVACY_POLICY} element={<PrivacyPolicy />} />
    </Routes>
  );
};
